import { createRouter, createWebHistory } from 'vue-router'
import Home from '../views/Home.vue'
import Listen from '../views/Listen.vue'
import Bericht from '../views/Bericht.vue'
import Message from '../views/Message.vue'
import Watch from '../views/Watch.vue'
import Missed from '../views/Missed.vue'
import Vrijwilliger from '../views/Vrijwilliger.vue'
import Adverteren from '../views/Adverteren.vue'
import Contact from '../views/Contact.vue'

import AdminDashboard from '../views/AdminDashboard.vue'

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/listen',
    name: 'Listen',
    component: Listen
  },
  {
    path: '/bericht',
    name: 'Bericht',
    component: Bericht
  },
  {
    path: '/message',
    name: 'Message',
    component: Message
  },
  {
    path: '/watch',
    name: 'Watch',
    component: Watch
  },
  {
    path: '/missed',
    name: 'Missed',
    component: Missed
  },
  {
    path: '/vrijwilliger',
    name: 'Vrijwilliger',
    component: Vrijwilliger
  },
  {
    path: '/adverteren',
    name: 'Adverteren',
    component: Adverteren
  },
  {
    path: '/contact',
    name: 'Contact',
    component: Contact
  },
  {
    path: '/admin',
    name: 'Admin',
    component: AdminDashboard,
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
